// Поля калькулятора юнит-экономики и их перевод в запрос сервера (/unit, /api/public/unit).
// Общие для прежнего калькулятора (он же на лендинге) и новой страницы «Расчёт цены».
// Проценты в полях — как их вводят (35 = 35%), сервер ждёт доли (0.35).

export const WB_PLANNING_WAREHOUSE_NAME = "Плановый тариф WB РФ — 170%";

export const SCHEMES = {
  wb: [
    { value: "fbw", label: "FBW" },
    { value: "fbs", label: "FBS" },
    { value: "dbs", label: "DBS" },
    { value: "edbs", label: "EDBS" },
    { value: "dbw", label: "DBW" },
    { value: "cc", label: "C&C" },
  ],
  ozon: [
    { value: "fbo", label: "FBO" },
    { value: "fbs", label: "FBS" },
    { value: "realfbs", label: "realFBS" },
  ],
};

export const TAX_SYSTEMS = [
  { value: "usn_income", label: "УСН доходы" },
  { value: "osn", label: "ОСН" },
];

export const DEFAULTS = {
  asOf: new Date().toISOString().slice(0, 10),
  price: undefined,
  priceBuyer: undefined,
  costPrice: undefined,
  buyoutRate: undefined,
  volumeLiters: undefined,
  weightKg: undefined,
  marketplaceDiscountRate: undefined,
  storageDays: undefined,
  warehouseCoeff: undefined,
  localizationCoeff: undefined,
  acceptanceCoeff: undefined,
  storageCoeff: undefined,
  acquiringRate: undefined,
  advertisingRate: undefined,
  processingCost: undefined,
  ownDeliveryCost: undefined,
  ownReturnCost: undefined,
  usnRate: undefined,
  vatRate: undefined,
  vatInput: undefined,
  otherCosts: undefined,
  taxSystem: "usn_income",
  storageClusterId: undefined,
  deliveryClusterId: undefined,
  wbWarehouseName: undefined,
  wbWarehouseMode: undefined,
};

export const PERCENT_FORM_FIELDS = [
  "buyoutRate",
  "marketplaceDiscountRate",
  "acquiringRate",
  "advertisingRate",
  "usnRate",
  "vatRate",
  "targetMargin",
];

export function normalizeCategoryText(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

export function getDefaultScheme(marketplace) {
  return marketplace === "wb" ? "fbw" : "fbo";
}

export function createFormDefaults(marketplace) {
  return {
    ...DEFAULTS,
    asOf: new Date().toISOString().slice(0, 10),
    marketplace,
    scheme: getDefaultScheme(marketplace),
  };
}

export function parseNumber(value) {
  if (value === undefined || value === null || value === "") return undefined;
  const parsed = Number(String(value).replace("%", "").replace(/\s/g, "").replace(/,/g, "."));
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function parseInputNumber(value) {
  return String(value || "")
    .replace("%", "")
    .replace(/\s/g, "")
    .replace(/,/g, ".");
}

export function rateToPercent(value) {
  const parsed = parseNumber(value);
  if (parsed === undefined) return undefined;
  const percent = Math.abs(parsed) <= 1 ? parsed * 100 : parsed;
  return Math.round((percent + Number.EPSILON) * 100) / 100;
}

export function percentToRate(value) {
  const parsed = parseNumber(value);
  return parsed === undefined ? undefined : parsed / 100;
}

export function inputToFormValues(input = {}, marketplace) {
  const values = {
    ...createFormDefaults(marketplace),
    ...input,
    marketplace,
    scheme: input.scheme || getDefaultScheme(marketplace),
  };

  PERCENT_FORM_FIELDS.forEach((field) => {
    values[field] = rateToPercent(values[field]);
  });

  delete values.title;
  delete values.mpCompensation;
  delete values.manualCommissionRate;
  return values;
}

export function formValuesToInput(values = {}, marketplace) {
  const input = {
    ...values,
    marketplace,
    categoryExternalId: values.categoryExternalId,
  };

  PERCENT_FORM_FIELDS.forEach((field) => {
    input[field] = percentToRate(input[field]);
  });

  delete input.title;
  delete input.mpCompensation;
  delete input.manualCommissionRate;
  delete input.warehouseCoeff;
  delete input.localizationCoeff;
  delete input.acceptanceCoeff;
  delete input.storageCoeff;
  if (marketplace === "wb" && ["fbw", "fbs"].includes(String(input.scheme || "").toLowerCase())) {
    input.wbWarehouseMode = "planning";
    input.wbWarehouseName = WB_PLANNING_WAREHOUSE_NAME;
  } else {
    delete input.wbWarehouseMode;
    delete input.wbWarehouseName;
  }
  return input;
}

export function mergeCategoryLists(current = [], next = []) {
  const byId = new Map();

  [...current, ...next].forEach((category) => {
    const externalId = String(category?.externalId || "").trim();
    if (!externalId) return;
    const previous = byId.get(externalId);
    const merged = { ...(previous || {}), ...category };

    if (
      (!Array.isArray(category?.commissionSchemes) || category.commissionSchemes.length === 0) &&
      Array.isArray(previous?.commissionSchemes)
    ) {
      merged.commissionSchemes = previous.commissionSchemes;
    }

    byId.set(externalId, merged);
  });

  return Array.from(byId.values()).sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""), "ru")
  );
}

export function getDefaultBuyoutPercent(category) {
  const text = normalizeCategoryText([
    ...(Array.isArray(category?.path) ? category.path : []),
    category?.name,
  ].filter(Boolean).join(" "));

  if (/плать|одеж|обув|бель|аксессуар|сумк|рюкзак|носок|колгот|перчат|шапк|головн|clothes|apparel|shoe|lingerie|accessor/.test(text)) {
    return 35;
  }

  if (/продукт|еда|питан|бакале|напит|чай|кофе|слад|молоч|мяс|рыб|food|grocery|drink|beverage/.test(text)) {
    return 90;
  }

  return 80;
}
